import { getApiUrl, getAxiosInstanceByLoginMode } from './shared';

const get = () => {
  return getAxiosInstanceByLoginMode().get(`${getApiUrl()}/delivery-frequencies`);
};

export { get };
